import * as Yup from "yup";
/* eslint-disable no-useless-escape */
export const SignInValidation = (t, countryCode) => { 
  return Yup.object({
  loginMethod: Yup.string().oneOf(["email", "phone_number"]).required(),

  email: Yup.string().when("loginMethod", (loginMethod, schema) => {
    return loginMethod[0] === "email"
      ? schema.required(t("auth.email.required")).matches(/^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,8})$/, 
          t("auth.email.validMessage")
        )
      : schema.notRequired();
  }),

  phone_number: Yup.string().when("loginMethod", (loginMethod, schema) => {
    return loginMethod[0] === "phone_number"
      ? schema
            .required(t("auth.phoneNumber.validMessage"))
            .matches(
              countryCode === "TR"
                ? /^\(\d{3}\)\s\d{3}\s\d{4}$/ // (XXX) XXX XXXX
                : /^\d{13}$/,                 // 13 rakam
              t("auth.phoneNumber.validMessage"))
      : schema.notRequired();
  }),
  countryCode: Yup.string().when("loginMethod", (loginMethod, schema) => {
    return loginMethod[0] === "phone_number"
      ? schema.required(t("auth.country.required"))
      : schema.notRequired();
  }),
  password: Yup.string().required(t("auth.password.passwordRequired")),
  });
}